import { Action } from 'redux';

import { applyDataRoleHack } from '../../app/spaces/CardView/DataRoleHack';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ExploreContentApi_ContentType } from '../../ts/ServerApi/types/IContent';
import { isHomeAddFavoriteSucceededAction, ishomeFetchFavoritesSucceededAction, ishomeFetchPopularSucceededAction, ishomeFetchRecentsSucceededAction, ishomeFetchRecommendationsSucceededAction, isHomeRemoveFavoriteSucceededAction } from '../actions/HomeActions';
import { NormalizedContent } from '../types/HomeTypes';

export const initialState: NormalizedContent = {};

export function normalizedContentKey(contentId: string, contentType: ExploreContentApi_ContentType) {
  // TODO: Remove this nasty hack when data-role team fixes TFSID 903843
  contentType = contentType.toString() === 'datarole' ? 'dataRole' : contentType;
  return `${contentType}:${contentId}`;
}

export function normalizedContentReducer(previousState: NormalizedContent = initialState, action: Action): NormalizedContent {
  if(ishomeFetchFavoritesSucceededAction(action) ||
     ishomeFetchRecentsSucceededAction(action) ||
     ishomeFetchRecommendationsSucceededAction(action) ||
     ishomeFetchPopularSucceededAction(action)) {
    const newState: NormalizedContent = {...previousState};
    action.result.items.forEach((item: IContentInfo) => {
      newState[normalizedContentKey(item.id, item.contentType)] = {...applyDataRoleHack<IContentInfo>(item)};
    });
    return newState;
  }

  if(isHomeAddFavoriteSucceededAction(action) || isHomeRemoveFavoriteSucceededAction(action)) {
    const key: string = normalizedContentKey(action.contentId, action.contentType);
    const newState: NormalizedContent = {...previousState};
    newState[key] = {...newState[key], favorite: isHomeAddFavoriteSucceededAction(action)};
    return newState;
  }
  return previousState;
}
